import React from 'react';
import { Box, AccordionButton, Heading, AccordionIcon, AccordionItem, AccordionPanel } from '@chakra-ui/core';
import { BusinessPositionT, BusinessT } from '../../calendar/types';
import PositionByBusinnessList from './PositionByBusinnessList';

interface Props {
  business: BusinessT;
  onCheckChange: (position: BusinessPositionT) => void;
}

function PositionBusinessListComponent({ business, onCheckChange }: Props) {
  return (
    <AccordionItem borderTopWidth="1px" borderTopColor="gray.50" borderBottomColor="gray.50" key={business.id}>
      {({ isExpanded }) => (
        <>
          <AccordionButton
            p={0}
            _focus={{
              boxShadow: 'none',
            }}
          >
            <Box flex="1" textAlign="left">
              <Heading py={2} as="h4" size="sm">
                {business.name}
              </Heading>
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel p={0}>
            <PositionByBusinnessList business={business} isActive={isExpanded} onCheckChange={onCheckChange} />
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  );
}

const PositionBusinessList = React.memo(PositionBusinessListComponent);
export default PositionBusinessList;
